__turbopack_context__.v({
  "links": "_r--BW_links",
  "links-desktop": "_r--BW_links-desktop",
  "links-mobile": "_r--BW_links-mobile",
});
